// extracted by mini-css-extract-plugin
export var cartIcon = "_ot-0";
export var cartIconContainer = "_ot-1";